import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from "../services/survey.service";
import { environment } from '../../environments/environment';
import { CacheService } from '../services/cache.service';

@Component({
  selector: 'app-return-to-work-acknowledgement',
  templateUrl: './return-to-work-acknowledgement.component.html',
  styleUrls: ['./return-to-work-acknowledgement.component.css']
})
export class ReturnToWorkAcknowledgementComponent implements OnInit {

  questions: SurveyQuestionVm[];
  showWelcomeText: boolean = true; 
  constructor(private surveyServiceProxy: SurveyService, private cacheService: CacheService) { }

  env: string;
  async ngOnInit() {
    this.env = environment.headerBanner;
    // this.stateService.hideHeaderSideBar();
    //this.router.navigate(['/return-to-work-acknowledgement']);
    const cachedData = this.cacheService.get('EMPRTW_Answers'); 
    this.questions = await this.surveyServiceProxy.getReturnToWorkAcknowledgementQuestions ().toPromise();
    console.log(this.questions);
    console.log('cachedData', cachedData);
    if (cachedData) {
      this.questions.forEach(q => {
        const mappedFieldName = this.mapQuestionFieldName(q.questionFieldName);
        
        let answer = cachedData.items.find(a => a.questionFieldName === mappedFieldName);
        if (answer) {
          q.answerText = answer.answerText;
        }
      });
    }
  }
  mapQuestionFieldName(questionFieldName: string): string {
    const mapping = {
      'RTWA_FirstName': 'EMPRTW_FirstName',
      'RTWA_LastName': 'EMPRTW_LastName',
      'RTWA_EmployeeId': 'EMPRTW_EmployeeId',
      'RTWA_Email': 'EMPRTW_Email',
      'RTWA_Phone': 'EMPRTW_Phone',
      'RTWA_NovantEmail': 'EMPRTW_NovantEmail'
    };
    return mapping[questionFieldName] || questionFieldName;
  }
  hideWelcomeText() {
    this.showWelcomeText = false;
  }

}
